import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=162820d6"
import script from "./Test.vue?vue&type=script&lang=ts"
export * from "./Test.vue?vue&type=script&lang=ts"
import style0 from "./Test.vue?vue&type=style&index=0&id=162820d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports